<template>
  <div class="card-row">
    <div
      v-auto-animate
      class="postal-input"
    >
      <TextInput
        v-model="postalCode"
        class="zipcode"
        label="Postcode"
        :inputmode="postalCodeInputMode"
        placeholder="1234 AB"
        @input="clearError"
      />
      <TextInput
        v-model.lazy="number"
        class="number"
        label="Huisnr."
        placeholder="1"
        inputmode="numeric"
        @input="clearError"
        @keyup.enter="submitPostalInput"
      />
      <TextInput
        v-model.lazy="numberExtension"
        class="extension"
        label="Toevoeging"
        placeholder="A"
        @input="clearError"
        @keyup.enter="submitPostalInput"
      />
      <button
        class="btn primary"
        @click="submitPostalInput()"
      >
        Check beschikbaarheid
        <Icon
          icon="arrow-right-long-solid"
          size="sm"
        />
      </button>
    </div>
    <FieldError :error="postalError" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import TextInput from '../../../vue-elements/input/TextInput.vue';
import FieldError from '../../../vue-elements/field/FieldError.vue';
import { addressData } from '../../../../assets/js/helpers/data';
import Icon from 'vue-elements/icon/Icon.vue';

import {
    validateHouseNumber,
    validatePostalCode,
} from '../../../../assets/js/helpers/validator';

const emit = defineEmits(['location', 'update:loading']);

defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
});

const postalCode = ref('');
const number = ref('');
const numberExtension = ref('');
const postalError = ref(null);

const clearError = () => {
    postalError.value = null;
};

const validatePostalInput = () => validatePostalCode(postalCode.value) && validateHouseNumber(number.value);

const submitPostalInput = () => {
    clearError();
    emit('update:loading', true);
    if (validatePostalInput()) {
        addressData('internet', '5Jm0k9yn1oQqCz6I-268', postalCode.value, `${number.value}${numberExtension.value ? `-${numberExtension.value}` : ''}`)
            .then((result) => {
                if (result.location.address_found) {
                    emit('location', result.location);
                } else {
                    postalError.value = 'Deze postcode en huisnummer combinatie is niet bekend';
                }
                emit('update:loading', false);
            });
    } else {
        postalError.value = 'Vul een geldige postcode en huisnummer in';
        emit('update:loading', false);
    }
};

const postalCodeInputMode = computed(() => {
    return postalCode.value.length >= 4 ? 'text' : 'numeric';
});

</script>
